import { combineReducers } from "redux";
import Authentication from "../slices/user/AuthSlice";
import ThemeSlice from "./theme/ThemeSlice";

const rootReducer = combineReducers({
  Authentication: Authentication,
  Theme: ThemeSlice,
});

export default rootReducer;
